// Unregister the asset-retry-sw.js service worker that was shipped in Vite 7
// builds. The plugin that registered it has been removed; without this call
// existing users would retain the orphaned SW indefinitely.
if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      for (const r of registrations) {
        if (r.active?.scriptURL.includes("asset-retry-sw")) r.unregister();
      }
    })
    .catch(() => {});
}
